import { useEffect, useState } from "react"
import type { DateTime } from "luxon"

import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { useDateTime } from "../../../../../localization/useDateTime"

/** The header's "Auto-saved X min ago" label, refreshed every half minute. */
export function useAutosavedLabel(lastEditedAt: DateTime | null): string {
    const { l10n } = useAppLocalization()
    const dateTimeFactory = useDateTime()

    const [, setTick] = useState(0)
    useEffect(() => {
        const interval = window.setInterval(() => setTick((tick) => tick + 1), 30_000)
        return () => window.clearInterval(interval)
    }, [])

    if (!lastEditedAt) return l10n.getString("merchant-week-menu-autosaved-label")
    const minutes = Math.floor(dateTimeFactory.now().diff(lastEditedAt, "minutes").minutes)
    if (minutes < 1) return l10n.getString("merchant-week-menu-autosaved-just-now")
    return l10n.getString("merchant-week-menu-autosaved-minutes", { minutes })
}
